import React, { useState } from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import SearchIcon from "@material-ui/icons/Search";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Avatar from "@material-ui/core/Avatar";
import CheckIcon from "@material-ui/icons/Check";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import ContentEditable from "react-contenteditable";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { formatTime } from "../../../../../helpers/time.helper";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    backgroundColor: "#3a3b3c",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "100%",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#FFFFFF99",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#FFFFFF99",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function MessageList(props) {
  const [activeTab, setActiveTab] = useState("1");
  const [filter, setFilter] = useState("");
  const {
    status,
    clientResponses,
    sendResponse,
    clear,
    textEditing,
    questionName,
    active,
    removeClientData,
    eventId,
  } = props;

  const searchFilter = (e) => {
    setFilter(e.target.value);
  };
  const sortResponses = () => {
    let res = [];
    clientResponses.map((cr, i) => {
      res.push({ ...cr, sortNo: i + 1 });
    });
    return res;
  };
  const renderMessage = (q, i) => {
    return (
      <Card
        key={i}
        className="dark-card"
        style={{ padding: "0px", margin: "0px" }}
      >
        <ListItem style={{ margin: "0px", padding: "0px" }} key={i}>
          <ListItemAvatar className="">
            <Avatar style={{ backgroundColor: "rgb(86, 175, 85)" }}>
              {q.sortNo}
            </Avatar>
          </ListItemAvatar>
          <div style={{ width: "calc(100% - 110px)" }}>
            <div style={{ width: "100%" }}>
              <div
                className="primary-text"
                style={{ margin: "5px 0px", fontSize: "15px" }}
              >
                {q.clientName}{" "}
                <div
                  style={{
                    fontSize: "12px",
                    color: "#ffffff99",
                    display: "inline-flex",
                    lineHeight: 2,
                  }}
                >
                  <AccessTimeIcon
                    style={{
                      color: "#ffffff99",
                      marginLeft: 10,
                      marginRight: 5,
                      marginTop: 5,
                      fontSize: "12px",
                    }}
                  />
                  {formatTime(q.inserted)}
                </div>
              </div>
            </div>
            <ContentEditable
              style={{
                backgroundColor: "#3a3b3c",
                marginBottom: "0px",
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                borderRadius: "5px",
                padding: "5px 10px",
                width: "100%",
              }}
              className="text-edit-area "
              html={q.answer}
              onChange={(e) => {
                textEditing(e.target.value, q.answerId);
                sendResponse({ ...q, answer: e.target.value });
              }}
              tagName="p"
            />
          </div>
          <ListItemSecondaryAction>
            {status == 1 ? (
              <IconButton
                edge="end"
                className="icon-button-dark-s"
                onClick={() => sendResponse({ ...q, status: 2 })}
              >
                <CheckIcon />
              </IconButton>
            ) : (
              <IconButton
                edge="end"
                className="icon-button-dark-s"
                onClick={() =>
                  sendResponse({ ...q, status: q.status === 2 ? 3 : 2 })
                }
              >
                {q.status === 2 ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      </Card>
    );
  };

  const classes = useStyles();
  const responses = sortResponses();

  return (
    <div style={{ marginTop: 10, overflowX: "hidden" }}>
      <div style={{ width: "100%", display: "inline-flex" }}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            onInput={searchFilter}
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      </div>
      {status === 1 ? (
        <List
          className="dark-list"
          style={{
            height: " calc(70vh - 40px)",
            overflowY: "auto",
          }}
        >
          {responses
            .filter((q) => {
              return (
                q.status < 2 &&
                q.answer !== null &&
                q.answer.toLowerCase().includes(filter.toLowerCase())
              );
            })
            .map((q, i) => {
              return renderMessage(q, i);
            })}
        </List>
      ) : null}
      {status === 2 ? (
        <List
          className="dark-list"
          style={{
            height: " calc(70vh - 40px)",
            overflowY: "auto",
          }}
        >
          {responses
            .filter((q) => {
              return (
                q.status > 1 &&
                q.answer !== null &&
                q.answer.toLowerCase().includes(filter.toLowerCase())
              );
            })
            .map((q, i) => {
                return renderMessage(q, i);
            //   return (
            //     <Card
            //       className="dark-card"
            //       style={{ padding: "0px 0px", margin: "0px" }}
            //     >
            //       <ListItem style={{ margin: "0px 0px" }} key={i}>
            //         <ListItemAvatar className="">
            //           <Avatar style={{ backgroundColor: "rgb(86, 175, 85)" }}>
            //             {q.sortNo}
            //           </Avatar>
            //         </ListItemAvatar>

            //         <div>
            //           <div style={{ width: "100%" }}>
            //             <div
            //               className="primary-text"
            //               style={{ margin: "5px 0px", fontSize: 15 }}
            //             >
            //               {" "}
            //               {q.clientName}{" "}
            //             </div>
            //           </div>
            //           <ContentEditable
            //             style={{
            //               backgroundColor: "#3a3b3c",
            //               marginBottom: "0px",
            //               color: "rgba(255, 255, 255, 0.6)",
            //               fontSize: "0.875rem",
            //               borderRadius: "5px",
            //               padding: "5px 10px",
            //             }}
            //             className="text-edit-area"
            //             /*         innerRef={this.contentEditable} */
            //             html={q.answer}
            //             onChange={(e) => {
            //               textEditing(e.target.value, q.answerId);
            //               sendResponse({ ...q, answer: e.target.value });
            //             }}
            //             tagName="p"
            //           />
            //           <div
            //             style={{
            //               fontSize: "12px",
            //               margin: "5px 0px",
            //               color: "#ffffff99",
            //               display: "inline-flex",
            //               lineHeight: "2em",
            //             }}
            //           >
            //             <AccessTimeIcon
            //               style={{
            //                 color: "#ffffff99",
            //                 marginRight: 5,
            //                 marginTop: 4,
            //                 fontSize: 16,
            //               }}
            //             />
            //             {formatTime(q.inserted)}
            //           </div>
            //         </div>
            //         <ListItemSecondaryAction>
            //           <IconButton
            //             edge="end"
            //             className="icon-button-dark-s"
            //             onClick={() =>
            //               sendResponse({ ...q, status: q.status === 2 ? 3 : 2 })
            //             }
            //           >
            //             {q.status === 2 ? (
            //               <VisibilityOffIcon />
            //             ) : (
            //               <VisibilityIcon />
            //             )}
            //           </IconButton>
            //         </ListItemSecondaryAction>
            //       </ListItem>
            //       <Divider variant="inset" component="li" />
            //     </Card>
            //   );
            })}
        </List>
      ) : null}
    </div>
  );
}
